<template>
	<div v-if="tickets && tickets.length > 0" class="row">
		<div class="col-12">

			<div class="card">
				<div class="card-header hg-underline" :style="bottomLineOverride">
					Tickets Selected
					<small v-if="event.fees_pass_on && hasPaidTickets">* (fees will be shown on payment screen)</small>
				</div>
				<div class="card-body">
					<table class="table table-tickets">
						<thead class='thead-light'>
							<th v-if="hasGroups">
								Group Name
							</th>
							<th style="width: 2%">&nbsp;</th>
							<th>Ticket Name</th>
							<th v-if="hasPaidTickets">Ticket Cost {{showVatInTitle}}</th>
							<th v-if="hasPaidTickets && event.show_vat && event.vat_exclusive">Ticket VAT Amount</th>
							<th>No of Tickets</th>
						</thead>
						<tfoot v-if="hasPaidTickets">
							<td v-if="hasGroups" class="hide-cell bsactualcoast"  :style="actualCostBG">
								&nbsp;
							</td>
							<td class="hide-cell bsactualcoast"  :style="actualCostBG">
								&nbsp;
							</td>
							<td class="hide-cell bsactualcoast"  :style="actualCostBG">TICKET TOTAL</td>
							<td data-label="TICKET TOTAL" class="bsactualcoast"  :style="actualCostBG">{{totalCost(tickets, discountValid) | currency('£')}}
							</td>
							<td data-label="VAT TOTAL"  class="bsactualcoast"  :style="actualCostBG" v-if="event.vat_exclusive">{{totalVatExc(tickets, discountValid) * 100 | currency('£')}}
							</td>
							<td class="hide-cell bsactualcoast"  :style="actualCostBG"></td>
						</tfoot>
						<tbody>
							<tr v-for="(ticket, idx) in orderBy(tickets, 'id')" :key="idx">

								<td v-if="hasGroups" :data-label="ticket.group_name == undefined ? ' ': ticket.group_name" class="group-name">
									<span class="gname">&nbsp;{{ticket.group_name}}</span>
								</td>

								<td class="hide-cell">
									<i class="fa fa-ticket ticketround" v-if="!ticket.child_ticket" :style="{backgroundColor: event.phcolour}" aria-hidden="true"></i>
									<i class="fa fa-ticket" v-if="ticket.child_ticket" aria-hidden="true"></i>
								</td>
								<td data-label="Ticket name" id="bsticketname" class="tickets">
									&nbsp;{{ticket.details}}
								</td>
								<td data-label="Ticket cost" id="bsticketcost" v-if="hasPaidTickets ">{{ticketCost(ticket, discountValid) | currency('£')}}
								</td>
								<td data-label="Ticket VAT Amount" v-if="hasPaidTickets && event.vat_exclusive ">{{ticketVatExc(ticket, discountValid) | currency('£')}}
								</td>
								<td  data-label="Number of tickets" id="bsnumberoftickets ">{{ticket.quantity_tickets}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import moment from "moment";

import costCalcs from "../common/cost-calcs";

import {mapGetters} from 'vuex';

import Vue2Filters from 'vue2-filters'

export default {
  mixins: [costCalcs, Vue2Filters.mixin],

  data: function() {
    return {
      tickets: [],
      discountValid: false,
      vatAmount: 20
    };
  },

  props: ["event", "headerText"],

  created() {
    this.tickets = this.$store.getters.getSelectedTickets;

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "setSelectedTickets") {
        this.tickets = mutation.payload;
      }
    });

    this.vatAmount = window.vatAmount;

    if (this.event && this.event.datetime_eb) {
      this.discountValid = moment(this.event.datetime_eb).isAfter(new Date());
    }
  },

  computed: {
  	...mapGetters({
      hasPaidTickets: 'getChargeable'
    }),
    hasGroups() {
      var counter = 0;

      this.tickets.forEach(ticket => {
        if (ticket.ticket_group_id) {
          counter += 1;
        }
      });

      return counter > 0;
    },

    bottomLineOverride() {
      return { borderBottom: "4px solid " + this.event.phcolour };
    },

	  actualCostBG(){
		return{backgroundColor: this.event.phcolour };
	  },  

    showVatInTitle() {
      if (this.event.show_vat) {
        return "(" + (this.event.vat_exclusive ? "exc" : "inc") + " VAT)";
      } else {
        return "";
      }
    }
  }

};
</script>

<style scoped>
/* .icon-styling {
  float: right;
  padding-top: 5px;
  color: rgb(255, 149, 0);
  font-size: large;
} */

.ticketround {
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  border-width: 10px;
  background: #ff9500;
  color: white;
  padding: 6px;
  font-size: 20px;
}

.sub {
  background-color: white !important;
  color: black;
}
</style>
